import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkTableVirtualScrollDataSource } from 'ng-table-virtual-scroll';
import { ToastrService } from 'ngx-toastr';
import { operationinterface } from 'src/app/interface/OperationInterface';
import { TableColmuns } from 'src/app/interface/TableColumnsinterface';
import { BrokerService } from 'src/app/services/broker.services';
import { GestionService } from 'src/app/services/gestion.services';
import { TemaService } from 'src/app/services/tema.services';
import { BrokerTimeService } from 'src/app/services/broker-time.service';
import { ColaOrdenesService } from 'src/app/services/cola-ordenes.service';
import { SlTpBrokerService, SlTpContexto } from 'src/app/services/sltp-broker.service';
import { OpesalidaDialogComponent } from '../../broker/opesalida-dialog/opesalida-dialog.component';
import { agregaTiporModelo, flattenArray, formatHoraCotizacion, formatFechaHoraCotizacion } from '../cartera-utils';

/** Tabla de posiciones de la cartera del broker (pestaña Posiciones Cartera y Control Operativa). */
@Component({
  selector: 'app-posiciones-broker',
  templateUrl: './posiciones-broker.component.html',
  styleUrl: './posiciones-broker.component.scss'
})
export class PosicionesBrokerComponent implements OnInit, OnDestroy {
  @Input() stkcfd: string = '';
  /** Alto del viewport; por defecto el de .wrapperBroker. */
  @Input() alto: string | null = null;
  /** En Control Operativa: cruza cada posición con su operación de ENTRADA (SL/TP, entrada API vs broker). */
  @Input() controlOperativa = false;
  /** Se emite al cerrar con éxito el diálogo de Operaciones de Salida. */
  @Output() salidaRealizada = new EventEmitter<void>();
  /** Órdenes de broker/listaordenes: de ellas sale el orderId de la entrada Filled de cada posición. */
  @Input() set ordenes(ordenes: any[] | null | undefined) {
    this.idOrdenPorIso.clear();
    const filled = (ordenes || [])
      .filter(o => o.status === 'Filled' && o.orderId && String(o.orderId) !== '0')
      .sort((a, b) => (Number(a.lastExecutionTime) || 0) - (Number(b.lastExecutionTime) || 0));
    // La más antigua por ID (companyName = isooper) es la entrada; las posteriores serían salidas parciales
    filled.forEach(o => {
      if (!this.idOrdenPorIso.has(o.companyName)) this.idOrdenPorIso.set(o.companyName, String(o.orderId));
    });
  }
  private idOrdenPorIso = new Map<string, string>();

  @ViewChild('brokerView', { static: false }) brokerView!: CdkVirtualScrollViewport;

  colPanelOpen = false;
  public isDark: boolean = false;
  theme: string | string[] | undefined;
  public brokPosdata: CdkTableVirtualScrollDataSource<operationinterface>;
  public brokOptimaWallet: any;
  private brokerOffsetMin: number | null = null;
  public filaSeleccionada: any;
  public opeVentas: any;
  public queryParams: string;
  contadorFilas: number;
  /** Operaciones transformadas de la cartera (ColaOrdenesService) y su ENTRADA por isooper. */
  private operacionesRaw: any[] = [];
  private operaciones: any[] = [];
  private entradasPorIso = new Map<string, any>();
  /** Selección por isooper: las filas se recrean en cada tick de cotización. */
  seleccion = new SelectionModel<string>(true, []);

  private subscriptions = new Subscription();

  tableColumns: TableColmuns[] = [
    { id: 'numoperaciones', name: 'N', isShow: true, isDate: false, isNumber: false, isString: true },
    { id: 'tipomodelo', name: 'Tipo Entrada', isShow: false, isDate: false, isNumber: false, isString: true },
    { id: 'isooper', name: 'ID', isShow: false, isDate: false, isNumber: false, isString: true },
    { id: 'idOrdenEntrada', name: 'Id Orden', isShow: true, isDate: false, isNumber: false, isString: false },
    { id: 'nombreCompania', name: 'Compañia', isShow: true, isDate: false, isNumber: false, isString: true },
    { id: 'fechaOperacion', name: 'Registro', isShow: true, isDate: true, isNumber: false, isString: false },
    { id: 'hora', name: 'Hora', isShow: false, isDate: false, isNumber: false, isString: true },
    { id: 'lastExecutionTimer', name: 'Ejecucion Broker', isShow: false, isDate: false, isNumber: false, isString: true },
    { id: 'precioentradareal', name: 'Entrada', isShow: true, isDate: false, isNumber: true, isString: false },
    { id: 'cantidadacciones', name: 'N° Acciones', isShow: true, isDate: false, isNumber: true, isString: false },
    { id: 'valorriesgo', name: 'Riesgo', isShow: false, isDate: false, isNumber: true, isString: false },
    { id: 'fechaCotizacion', name: 'Fecha Actual', isShow: false, isDate: true, isNumber: false, isString: false },
    { id: 'horaCotizacion', name: 'Hora Cotización', isShow: true, isDate: false, isNumber: false, isString: true },
    { id: 'cotizacion', name: 'Cotizacion', isShow: true, isDate: false, isNumber: true, isString: false },
    { id: 'stoploss', name: 'Stoploss', isShow: false, isDate: false, isNumber: true, isString: false },
    { id: 'stoplossactual', name: 'Stoploss Actual', isShow: false, isDate: false, isNumber: false, isString: true },
    { id: 'profit', name: 'Profit', isShow: false, isDate: false, isNumber: false, isString: true },
    { id: 'valorlatente', name: 'Beneficio', isShow: true, isDate: false, isNumber: true, isString: false },
    { id: 'valorlatentepor', name: 'Beneficio %', isShow: true, isDate: false, isNumber: true, isString: false },
    { id: 'margenbroker', name: 'Margen B', isShow: true, isDate: false, isNumber: true, isString: false },
  ];

  displayedColumns: string[] = ['numoperaciones', 'isooper', 'idOrdenEntrada', 'nombreCompania', 'fechaOperacion', 'hora'
    , 'precioentradareal', 'cantidadacciones', 'horaCotizacion', 'cotizacion',
    'valorlatente', 'valorlatentepor', 'margenbroker'];

  constructor(private _broker: BrokerService,
    private _gestorsv: GestionService,
    private temaService: TemaService,
    private brokerTimeService: BrokerTimeService,
    private datePipe: DatePipe,
    private dialog: MatDialog,
    private toastr: ToastrService,
    private colaOrdenesService: ColaOrdenesService,
    public sltp: SlTpBrokerService,
    private cdr: ChangeDetectorRef) {
    this.brokPosdata = new CdkTableVirtualScrollDataSource<operationinterface>();
  }

  ngOnInit(): void {
    if (this.controlOperativa) {
      this.tableColumns.push(
        { id: 'entradaApiBroker', name: 'Entrada Api / Broker', isShow: false, isDate: false, isNumber: false, isString: false },
        { id: 'spread', name: 'Spread Broker', isShow: true, isDate: false, isNumber: false, isString: false });
      this.displayedColumns = [...this.displayedColumns, 'spread','select'];
      this.subscriptions.add(this.colaOrdenesService.operaciones$.subscribe(ops => {
        this.operacionesRaw = ops;
        this.indexarOperaciones();
      }));
    }
    this.subscriptions.add(this._broker.valBrokValPos$.subscribe({
      next: (datos: any) => {
        this.brokPosdata.data = this.formatoHora(agregaTiporModelo(flattenArray(datos)));
        if (this.brokerView) { this.brokerView.checkViewportSize(); }
      }
    }));
    this.subscriptions.add(this._broker.valBrokOptimaWallet$.subscribe({
      next: (data: any) => {
        if (data.nombre) {
          this.brokOptimaWallet = data;
          this.indexarOperaciones();
          if (this.brokOptimaWallet.tipoBroker === 'METAAPI') {
            const accountId = this.brokOptimaWallet.metaApiAccountId || this.brokOptimaWallet.nombre;
            this.brokerTimeService.getOffsetMinutes(accountId).subscribe(offsetMin => this.brokerOffsetMin = offsetMin);
          } else {
            this.brokerOffsetMin = null;
          }
        }
      }
    }));
    // openDialog envía opeVentas al diálogo de salida (mismo origen que tenía app-cartera)
    this.subscriptions.add(this._gestorsv.valGestValPos$.subscribe({
      next: (data: any) => { this.opeVentas = data; }
    }));
    this.subscriptions.add(this.temaService.valDarkTheme.subscribe({
      next: (data: any) => {
        this.isDark = data;
        this.theme = data ? 'dark-theme' : 'light-theme';
      }
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  /** El viewport virtual mide 0 mientras la pestaña está oculta: recalcular al mostrarse. */
  actualizarViewport() {
    if (this.brokerView) {
      this.brokerView.checkViewportSize();
      this.cdr.detectChanges();
    }
  }

  expandirColPanel() { this.colPanelOpen = true; }
  contraerColPanel() { this.colPanelOpen = false; }

  toggleColumnVisibility(id: any) {
    const column = this.tableColumns.find(col => col.id === id);
    if (column) {
      column.isShow = !column.isShow;
      this.displayedColumns = this.tableColumns.filter(col => col.isShow).map(col => col.id);
      if (this.controlOperativa) this.displayedColumns.push('select');
    }
  }

  private indexarOperaciones() {
    if (!this.controlOperativa || !this.brokOptimaWallet?.idcartera) return;
    this.operaciones = this.sltp.transformarOperaciones(this.operacionesRaw, this.brokOptimaWallet.idcartera);
    this.entradasPorIso.clear();
    this.operaciones.filter(op => op.tipoOperacion === 'ENTRADA').forEach(op => this.entradasPorIso.set(op.isooper, op));
  }

  /** Operación de ENTRADA asociada a la posición, si la hay. */
  operacionDe(row: any): any {
    return this.entradasPorIso.get(row?.isooper);
  }

  /** orderId de la orden de entrada Filled de la posición, si está en la lista de órdenes. */
  idOrdenEntrada(row: any): string {
    return this.idOrdenPorIso.get(row?.isooper) ?? '';
  }

  todasSeleccionadas(): boolean {
    const isos = this.brokPosdata.data.filter(r => this.operacionDe(r)).map(r => r.isooper);
    return isos.length > 0 && isos.every(iso => this.seleccion.isSelected(iso));
  }

  toggleTodas() {
    if (this.todasSeleccionadas()) {
      this.seleccion.clear();
    } else {
      this.brokPosdata.data.filter(r => this.operacionDe(r)).forEach(r => this.seleccion.select(r.isooper));
    }
  }

  /** SL/TP sobre las posiciones marcadas o, si no hay ninguna, sobre la del clic derecho. */
  accionSlTp(accion: 'establecerSL' | 'actualizarSL' | 'cancelarSL' | 'establecerTP' | 'cancelarTP') {
    const isos = this.seleccion.selected.length ? this.seleccion.selected : [this.filaSeleccionada?.isooper];
    const ops = isos.map(iso => this.entradasPorIso.get(iso)).filter(op => !!op);
    if (!ops.length) {
      this.toastr.warning('La posición no tiene una operación asociada en la cartera.');
      return;
    }
    const w = this.brokOptimaWallet;
    const ctx: SlTpContexto = {
      idcartera: w.idcartera,
      cartera: String(w.nombre).toUpperCase(),
      tipoBroker: w.tipoBroker ?? 'IBKR',
      metaApiAccountId: w.metaApiAccountId ?? '',
      operaciones: this.operaciones,
      panelClass: this.isDark ? 'dark-theme' : 'light-theme'
    };
    this.sltp[accion](ops, ctx);
  }

  selectRow(row: any) {
    this.filaSeleccionada = row;
    this._broker.updateBrokFechaFiltro(this.filaSeleccionada.fechaOperacion);
  }

  mostrarMenu(event: MouseEvent, data: any) {
    event.preventDefault(); // Evitar menú contextual del navegador
    this.filaSeleccionada = data;
  }

  verGrafica() {
    const jsonData = {
      idNectum: this.filaSeleccionada.idNectum,
      nombreComp: this.filaSeleccionada.nombreCompania,
      idModelo: this.filaSeleccionada.idcartera.toString(),
      isModelo: 'grafica'
    };
    this.queryParams = new URLSearchParams(jsonData).toString();
    window.open('/grafica-modelo/' + this.queryParams, '_blank');
  }

  verModelo() {
    if (this.filaSeleccionada.idmodelo !== 0) {
      const jsonData = {
        idNectum: this.filaSeleccionada.idNectum,
        nombreComp: this.filaSeleccionada.nombreCompania,
        idModelo: this.filaSeleccionada.idmodelo,
        isModelo: 'modelo',
        fecha: this.filaSeleccionada.fechaOperacion
      };
      this.queryParams = new URLSearchParams(jsonData).toString();
      window.open('/grafica-modelo/' + this.queryParams, '_blank');
    } else {
      this.toastr.success('Selecciona correctamente el activo para ver modelo.', '', { timeOut: 3000, positionClass: 'toast-bottom-center' });
    }
  }

  openDialog(): void {
    const fila = JSON.parse(JSON.stringify(this.filaSeleccionada));
    const operaciones = JSON.parse(JSON.stringify(this.opeVentas));
    const dialogRef = this.dialog.open(OpesalidaDialogComponent, {
      width: '420px',
      maxWidth: '95vw',
      height: '640px',
      maxHeight: '90vh',
      panelClass: this.isDark ? 'dark-theme' : 'light-theme',
      data: {
        compania: fila,
        opeventas: operaciones,
        optimaWallet: this.brokOptimaWallet,
        stkcfd: this.stkcfd,
        isBroker: true,
        isPosiciones: false,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.salidaRealizada.emit();
      }
    });
  }

  orderByField(campo: string) {
    const dataTemp = this.brokPosdata.data;
    if (campo === 'fechaOperacion') {
      dataTemp.sort((a, b) => new Date(b.fechaOperacion).getTime() - new Date(a.fechaOperacion).getTime());
    } else if (campo === 'nombreCompania') {
      dataTemp.sort((a, b) => {
        const nameA = a.nombreCompania.toLowerCase();
        const nameB = b.nombreCompania.toLowerCase();
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      });
    } else {
      return;
    }
    this.brokPosdata.data = this.updateCounter([...dataTemp]);
    this.cdr.detectChanges();
  }

  updateCounter(data: operationinterface[]): operationinterface[] {
    this.contadorFilas = 0; // Reinicia el contador del lote
    return data.map(item => {
      item.numoperaciones = ++this.contadorFilas;
      return item;
    });
  }

  formatoHora(data: operationinterface[]): operationinterface[] {
    return data.map(item => {
      const date = new Date(item.hora * 1000);
      const timePart = this.brokOptimaWallet?.tipoBroker === 'METAAPI'
        ? this.brokerTimeService.formatTime(date, this.brokerOffsetMin)
        : date.toLocaleTimeString();
      return { ...item, horaFormato: timePart };
    });
  }

  formatHoraCotizacion(timestamp: number): string {
    return formatHoraCotizacion(timestamp, this.brokOptimaWallet, this.brokerOffsetMin, this.datePipe, this.brokerTimeService);
  }

  formatFechaHoraCotizacion(timestamp: number): string {
    return formatFechaHoraCotizacion(timestamp, this.brokOptimaWallet, this.brokerOffsetMin, this.datePipe, this.brokerTimeService);
  }
}
